import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { BuyerFAQ, StyledAccordion, TypographyWrapper } from '..';
import { useEnabledCustomerExperiences } from '../../hooks/useEnabledCustomerExperiences';
import NamedLink from '../NamedLink/NamedLink';
import SellerFAQ from '../SellerFAQ/SellerFAQ';
import css from './FAQ.module.css';
import { TypographyFormat } from '../TypographyWrapper/TypographyWrapper';

const FAQ = (props) => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  const { allowSell, allowBuy } = useEnabledCustomerExperiences();

  return (
    <div className={classes}>
      {allowBuy && (
        <>
          <h2>
            <TypographyWrapper variant="h2" typographyOverrides={{ style: { fontWeight: 'bold' } }}>
              Buyer FAQs
            </TypographyWrapper>
          </h2>
          <BuyerFAQ />
        </>
      )}
      {allowSell && (
        <>
          <h2>
            <TypographyWrapper variant="h2" typographyOverrides={{ style: { fontWeight: 'bold' } }}>
              Seller FAQs
            </TypographyWrapper>
          </h2>
          <SellerFAQ />
        </>
      )}

      <h2>
        <TypographyWrapper variant="h2" typographyOverrides={{ style: { fontWeight: 'bold' } }}>
          Misc. FAQs
        </TypographyWrapper>
      </h2>
      <StyledAccordion name="what-is-treet">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel11a-content"
          id="panel11a-header"
        >
          <h4>
            <TypographyWrapper
              variant="body1"
              typographyOverrides={{ style: { fontWeight: 'bold' } }}
            >
              What is Treet?
            </TypographyWrapper>
          </h4>
        </AccordionSummary>
        <AccordionDetails>
          <span>
            <h4>
              <TypographyWrapper variant="body1">
                Treet is the platform we use to power this site. They handle all of the shipping
                logistics, disbursements, refunds/returns, and product authentications to make this
                site a safe environment for {allowBuy ? 'buying and ' : ''}selling.
              </TypographyWrapper>
            </h4>
            <h4>
              <TypographyWrapper variant="body1">
                Visit{' '}
                <NamedLink name="AboutTreetPage">
                  <TypographyWrapper
                    variant="body1"
                    typographyOverrides={{ display: 'inline' }}
                    format={TypographyFormat.Underlined}
                  >
                    this page
                  </TypographyWrapper>
                </NamedLink>{' '}
                for more information about Treet.
              </TypographyWrapper>
            </h4>
          </span>
        </AccordionDetails>
      </StyledAccordion>
    </div>
  );
};

FAQ.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

FAQ.propTypes = {
  rootClassName: string,
  className: string,
};

export default FAQ;
